Vue.asyncComponent('cms-password-reset-form',{
    data() {
        return {
            loading: false,
            showSuccess: false,
            showForm: false,
            errors: {
                password: null,
                passwordConfirm: null,
            },
            password: null,
            passwordConfirm: null,
        }
    },
    computed: {
        /**
         * Get the token from the current route
         * @return {*}
         */
        token() {
            return this.$route.query.token;
        }
    },
    methods: {
        async submit() {
            this.loading = true;
            this.error = null;

            // construct the post data
            const data = {
                token: this.token,
                password: this.password,
                passwordConfirm: this.passwordConfirm
            }

            // do submit call
            let result = await this.$post(this.$getSetting('paths.baseAuth') + '/user/password-reset', data);

            this.loading = false;

            if (!result.success) {
                this.errors = result.errors;
            } else {
                this.showSuccess = true;
            }

            // If we have actions to handle
            if(result.todos) {
                this.$actionHandler.handle(result.todos, this);
            }
        },
        toLogin() {
            this.$router.push({name: 'login'});
        },
        async checkToken() {
            this.loading = true;

            // construct the post data
            const params = {
                token: this.token,
            }

            // do submit call
            let result = await this.$get(this.$getSetting('paths.baseAuth') + '/user/password-reset-token/', params);

            this.loading = false;

            if (result.success) {
                this.showForm = true;
            }

            // If we have actions to handle
            if(result.todos) {
                this.$actionHandler.handle(result.todos, this);
            }
        }
    },
    created() {
        this.checkToken();
    }
}, 'cms/form/cms-password-reset-form.html');